import React from 'react';
import { useStaticQuery, graphql, Link } from 'gatsby'
import PropTypes from 'prop-types';

function FAQIndex ({category}) {

    const results = useStaticQuery(graphql`
        query FAQIndexQuery {
            faqs: allNodeFaq(sort: {title: ASC}) {
            edges {
                node {
                title
                drupal_id
                drupal_internal__nid
                path {
                    alias
                }
                relationships {
                    field_faq_category {
                    name
                    }
                }
                }
            }
            }
        }
    `)

    let data = results.faqs.edges;

    // Filter by category
    if (category) {
        data = data.filter((faq) => {
            return faq.node.relationships.field_faq_category.name === category;
        })
    }

    function get_anchor_link(faq) {
        return "#" + faq.node.drupal_internal__nid;
    }

    const faq_links = data.map((faq) => {
        return (
            <li>
                <Link to={get_anchor_link(faq)}>
                    {faq.node.title}
                </Link>
            </li>
        )
    })
    
    return (<>
        <ul>
            {faq_links}
        </ul>
    </>);
       
}

FAQIndex.propTypes = {
	category: PropTypes.string,
}

FAQIndex.defaultProps = {
    category: "General"
}

export default FAQIndex